class LexieBlogCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.track = this.querySelector('.lexie-blog-carousel__track');
    this.slides = Array.from(this.track?.children || []);
    if (!this.track || this.slides.length === 0) return;

    this.dataset.initialized = 'true';
    this.index = 0;
    this.previousButton = this.querySelector('[data-lexie-blog-previous]');
    this.nextButton = this.querySelector('[data-lexie-blog-next]');
    this.currentLabel = this.querySelector('[data-lexie-blog-current]');
    this.totalLabel = this.querySelector('[data-lexie-blog-total]');
    this.dotsContainer = this.querySelector('.lexie-blog-carousel__dots');

    this.slides.forEach((slide, index) => {
      slide.classList.add('lexie-blog-carousel__slide');
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
    });

    this.dots = this.slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'lexie-blog-carousel__dot';
      dot.setAttribute('aria-label', `Afficher l’article ${index + 1}`);
      dot.addEventListener('click', () => this.goTo(index));
      this.dotsContainer.append(dot);
      return dot;
    });

    this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
    this.track.addEventListener('scroll', () => this.queueSync(), { passive: true });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      if (event.key === 'ArrowRight') this.goTo(this.index + 1);
    });

    this.totalLabel.textContent = String(this.slides.length).padStart(2, '0');
    this.update();
  }

  queueSync() {
    cancelAnimationFrame(this.syncFrame);
    this.syncFrame = requestAnimationFrame(() => {
      const width = this.track.clientWidth || 1;
      const nextIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
      if (nextIndex !== this.index) {
        this.index = nextIndex;
        this.update();
      }
    });
  }

  goTo(index) {
    const count = this.slides.length;
    this.index = (index + count) % count;
    this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
    this.update();
  }

  update() {
    this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');
    this.slides.forEach((slide, index) => {
      slide.toggleAttribute('inert', index !== this.index);
      slide.classList.toggle('is-current', index === this.index);
    });
    this.dots.forEach((dot, index) => dot.classList.toggle('is-current', index === this.index));
  }
}

if (!customElements.get('lexie-blog-carousel')) {
  customElements.define('lexie-blog-carousel', LexieBlogCarousel);
}
